import { render, staticRenderFns } from "./RedesignExtensionCard.vue?vue&type=template&id=09611430&scoped=true"
import script from "./RedesignExtensionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignExtensionCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignExtensionCard.vue?vue&type=style&index=0&id=09611430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09611430",
  null
  
)

export default component.exports